module.exports = __webpack_public_path__ + "img/logo.a97637a5.png";